// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import DataViewer from '../core/data-viewer';
import Error from '../core/error';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-json.scss';

const servicesDataKey = 'mediaItemJsonReceived';

class MediaItemJSON extends Component {
    getDataViewerProps() {
        return {
            className: 'mediaitem-json--data-viewer',
            defaultExpandKeys: ['vodProgram'],
            searchData: this.getJsonData(),
        };
    }

    getJsonData() {
        const {searchData} = this.props;

        return [get(searchData, '0.json')];
    }

    getMediaItemGuid() {
        const {routerParams} = this.props;

        return routerParams.guid;
    }

    getPaginationProps() {
        return {
            maxResults: 50000,
            maxPages: 9,
        };
    }

    getRecordDetailsProps() {
        return {
            blacklistKeys: ['json'],
            className: 'mediaitem-json--record-details',
            whitelistKeys: ['guid', 'dateCreated', 'lastUpdated'],
        };
    }

    renderDataViewer() {
        const {searchData} = this.props;

        return searchData.length ? (
            <DataViewer {...this.getDataViewerProps()} />
        ) : (
            <div className="mediaitem-json--no-items">Farallon data not available for this Media Item.</div>
        );
    }

    render() {
        const {fetching, searchData} = this.props;

        return this.getMediaItemGuid() ? (
            <div className="mediaitem-json">
                <div className="mediaitem-json--content">
                    <div className="mediaitem-json--title">Media Item JSON Received</div>
                    <RecordDetails {...this.getRecordDetailsProps()} searchData={searchData} />
                    <div className="mediaitem-json--title">Farallon Data</div>
                    {this.renderDataViewer()}
                    <Loading loading={fetching} />
                </div>
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

MediaItemJSON.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array.isRequired,
};

export default withSearch(MediaItemJSON, servicesDataKey);
